import React, { useMemo } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChargingSessionModel } from '../models/charging-sessions.model'
import { CurrentSort, SortMenu } from '@e3dc-react/shell/Elements/Table'
import { SortOption } from '@e3dc-react/shell/Elements/Sort'

interface ChargingSessionSortMenuProps {
  value: CurrentSort<ChargingSessionModel>
  shouldDisplayMidMeter: boolean
  onChange: (sort: CurrentSort<ChargingSessionModel>) => void
}

export const ChargingSessionSortMenu: React.FC<ChargingSessionSortMenuProps> = ({ value, shouldDisplayMidMeter, onChange }) => {
  const { t } = useCustomTranslation()
  const mobileSortableColumns: SortOption<ChargingSessionModel>[] = useMemo(
    () => [
      { value: 'startDateTime', label: t('emobility.chargingSession.startAt') },
      { value: 'durationMilliseconds', label: t('emobility.chargingSession.duration') },
      { value: 'consumptionKWh', label: t('emobility.chargingHistory.consumption') },
      { value: 'solarEnergyRatio', label: t('emobility.chargingSession.solarEnergyRatio') },
      { value: 'totalCost', label: t('emobility.chargingSession.cost') },
      { value: 'wallbox', label: t('emobility.chargingSession.wallbox') },
      { value: 'status', label: t('emobility.chargingSession.status') },
      { value: 'authentication', label: t('emobility.chargingSession.authentication') },
      ...(shouldDisplayMidMeter ? [{ value: 'midInfo' as const, label: t('emobility.chargingSession.mid-meter-info') }] : []),
    ],
    [t, shouldDisplayMidMeter]
  )

  return <SortMenu sortableColumns={mobileSortableColumns} value={value} onChange={onChange} />
}
